import { PAGINATION_KIND } from 'modules/core/components/DataTable/constants'
import type { PaginationType } from 'modules/core/components/DataTable/types'

import CursorPagination from './CursorPagination'
import OffsetPagination from './OffsetPagination'

interface Props {
  pagination: PaginationType
  loading: boolean
}

function Pagination({ pagination, loading }: Props) {
  switch (pagination.kind) {
    case PAGINATION_KIND.OFFSET:
      return <OffsetPagination />
    case PAGINATION_KIND.CURSOR:
      return <CursorPagination loading={loading} />
  }
}

export default Pagination
